{
    "FTP_PATH": "/gwjp/",
    "PLATFORM": "jp",
    "LANGUAGE": "ja-JP",
    "EFE_ACTIVITY_HOST": "https://efe-activity.efunjp.com/",
    "PF_HOST": "https://pf.efunjp.com/",
    "PF_WEB_HOST": "https://m.efunjp.com/",
    "IMG_HOST": "https://imgi.efunjp.com/",
    "LOGIN_HOST": "https://login.efunjp.com/",
    "GAME_HOST": "https://game.efunjp.com/",
    "LOGIN_WEB_PATH": "https://m.efunjp.com/enter/login?from=",
    "CDN_HOST": "https://resjp-download.vsplay.com/res_jp",
    "PLATFORM_GAME_CODE": "efunjpplatform",
    "GAME_GPID": 1,
    "GAME_DEPT": 48,
    "FB_APP_ID": "821833207348226",
    "COOKIE_DOMAIN": "efunjp.com",
    "CODE_VERSION": "1.0",
    "gameCode": "jpklqb",
    "activityCode": "jpklqbPre"
}
